import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "asset-data",
  "use": "asset-data-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"asset-data\"><g fill=\"var(--bolt-theme-icon, currentColor)\" fill-rule=\"evenodd\"><path d=\"M11 20h2V4h-2v16zm2-18h-2a2 2 0 00-2 2v16c0 1.1.9 2 2 2h2a2 2 0 002-2V4a2 2 0 00-2-2zM19 20h2V9h-2v11zm2-13h-2a2 2 0 00-2 2v11c0 1.1.9 2 2 2h2a2 2 0 002-2V9a2 2 0 00-2-2zM3 20h2v-6H3v6zm2-8H3a2 2 0 00-2 2v6c0 1.1.9 2 2 2h2a2 2 0 002-2v-6a2 2 0 00-2-2z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol